


















































import Vue from "vue";

interface State {
  iconYes: string;
  iconNo: string;
  iconUnknown: string;
  iconRemove: string;
}
export default Vue.extend({
  name: "EventRowAvailabilityActionsModal",
  props: {
    invite: {
      type: Object,
      required: false,
      default: null
    },
    playerId: {
      type: String,
      required: false
    },
    event: {
      type: Object,
      required: false
    }
  },
  data: (): State => ({
    iconYes: "mdi-check-bold",
    iconNo: "mdi-cancel",
    iconUnknown: "mdi-clock-outline",
    iconRemove: "mdi-close"
  }),
  methods: {
    setPlayerAvailability(status: string, invite: object): void {
      if (this.invite) {
        this.$emit("setPlayerAvailability", { status: status, invite: invite });
      } else {
        this.$emit("setPlayerAvailability", {
          status: status,
          playerId: this.playerId,
          event: this.event
        });
      }
    },
    removePlayer(invite: object): void {
      this.$emit("removePlayer", { invite: invite });
    }
  }
});
